

exports.__esModule = true;
exports.$xoGenericMessagePageComponent = undefined;

var _squid = require('squid');

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

require('xo-models/src/checkout/index');

require('xo-ui-components/src/generic-message/directive');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoGenericMessagePageComponent = exports.$xoGenericMessagePageComponent = _squid.$Component.extend('$xoGenericMessagePageComponent', {
    tag: 'xo-generic-message-page',
    template: _template2['default'],

    controller: function controller($scope, $rootScope, // eslint-disable-line no-shadow
    $stateParams, $state, $logger, $CheckoutAppDataModel, $util, $q, $populate) {

        $scope.token = $rootScope.token;

        (0, _jquery2['default'])('#defaultCancelLink').hide();

        $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
            event.preventDefault();
        });
    }
});

angular.value("$xoGenericMessagePageComponent", $xoGenericMessagePageComponent);
_squid.$Component;


//////////////////
// WEBPACK FOOTER
// ./pages/xo-generic-message/directive.js
// module id = ./pages/xo-generic-message/directive.js
// module chunks = 0